import { FC } from 'react'
import { SequenceMenu } from '@sequencehq/core-components'
import { CreditNote } from 'CreditNotes/types'
import { DownloadCreditNotePdfProps } from 'CreditNotesList/useCreditNotePdfDownload'

type Props = {
  creditNoteId: CreditNote['id']
  creditNoteNumber: CreditNote['creditNoteNumber']
  creditNoteStatus: CreditNote['status']
  onClose: () => void
  downloadPdf: (props: DownloadCreditNotePdfProps) => void
}

export const DownloadCreditNoteMenuItem: FC<Props> = ({
  creditNoteId,
  creditNoteNumber,
  creditNoteStatus,
  onClose,
  downloadPdf
}) => (
  <SequenceMenu.Item
    uuid="download-credit-note"
    data-testid={`creditNotes.${creditNoteId}.menuItem.download`}
    label="Download credit note as PDF"
    onClick={e => {
      e.stopPropagation()
      onClose()
      downloadPdf({ creditNoteId, creditNoteNumber, creditNoteStatus })
    }}
  />
)
